// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2kdSi","validationTips":"StatementDescriptor_validationTips__JzNkx"};